<template>
  <div class="index">
     <indexHeader></indexHeader>
      <div class="w1200">
           
            <div class="flex mt_50">
                <div class="flex-1 mr_70">
                    <div class="title1">{{infor.jyfa.title2}}</div>
                    <div class="title2 mt_10">{{infor.jyfa.title}}</div>
                    <div class="desc mt_15" v-html="infor.jyfa.content"></div>
                </div>
                <img class="ban1" :src="$imgurl(infor.jyfa.image)">
            </div>
            <div class="font40 mt_90">智能方案设计平台的优势</div>
             <el-tabs class="mt_40" v-model="activeName" @tab-click="handleClick">
              <el-tab-pane v-for="(item,index) in infor.ptys" :key="index" :label="item.lanmu" :name="index+''">
                   <div class="mt_20 flex">
                        <img class="mr_50 ban1" :src="$imgurl(item.image)">
                        <div class="flex-1">
                              <div class="title2">{{item.title}}</div>
                              <div class="desc mt_20" v-html="item.content"></div>
                        </div>  
                   </div>
              </el-tab-pane>
              <!-- <el-tab-pane label="智能模板库" name="second">智能模板库</el-tab-pane>
              <el-tab-pane label="数据采集" name="third">数据采集</el-tab-pane> -->
            </el-tabs>
            <div class="font40 mt_80 bordiv">用户获益</div>
            <el-row :gutter="30" class="mt_45">
                <el-col :span="6" v-for="(item,index) in infor.yhhy" :key="index">
                      <div class="hydiv">
                        <div  class="num">{{item.bfb}}</div>
                        <div class="hy1">{{item.title}}</div>
                        <div class="hydesc">{{item.des}}</div>
                      </div>
                </el-col>
                <!-- <el-col :span="6">
                      <div class="hydiv">
                        <div  class="num">90%</div>
                        <div class="hy1">节省写作时间</div>
                        <div class="hydesc">数据清单生成用时缩短</div>
                      </div>
                </el-col>
                <el-col :span="6">
                      <div class="hydiv">
                        <div  class="num">90%</div>
                        <div class="hy1">节省写作时间</div>
                        <div class="hydesc">数据清单生成用时缩短</div>
                      </div>
                </el-col>
                <el-col :span="6">
                      <div class="hydiv">
                        <div  class="num">90%</div>
                        <div class="hy1">节省写作时间</div>
                        <div class="hydesc">数据清单生成用时缩短</div>
                      </div>
                </el-col> -->
            </el-row>  
             <div class="font40 mt_80 bordiv">解决方案</div>
             <el-collapse v-model="jjfa" accordion>
              <el-collapse-item v-for="(item,index) in infor.jjfa" :key="index" :title="item.title" :name="index+''">
                   <div class="flex jjfabox">
                          <div class="flex-1">
                              <div v-html="item.content"></div>
                            <div class="sybtn" @click="gourl(item.linkurl)">立即使用</div>
                           </div> 
                           <img :src="$imgurl(item.image)" class="faimg">
                   </div> 
              </el-collapse-item>
              <!-- <el-collapse-item title="机构学术版" name="2">
                <div class="flex jjfabox">
                          <div class="flex-1">
                              <div>这里放个人学术版的一些功能简介，包括应用范围，应用场景，模块数量等等。这里放个人学术版的一些功能简介，包括应用范围，应用场景，模块数量等等。这里放个人学术版的一些功能简介，包括应用范围，应用场景，模块数量等等。这里放个人学术版的一些功能简介，包括应用范围，应用场景，模块数量等等。这里放个人学术版的一些功能简介，包括应用范围，应用场景，模块数量等等。这里放个人学术版的一些功能简介，包括应用范围，应用场景，模块数量等等。这里放个人学术版的一些功能简介，包括应用范围，应用场景，模块数量等等。</div>
                            <div class="sybtn">立即使用</div>
                           </div> 
                           <img src="@/assets/ban3.png" class="faimg">
                   </div> 
              </el-collapse-item>
              <el-collapse-item title="商业学术版" name="3">
               <div class="flex jjfabox">
                          <div class="flex-1">
                              <div>这里放个人学术版的一些功能简介，包括应用范围，应用场景，模块数量等等。这里放个人学术版的一些功能简介，包括应用范围，应用场景，模块数量等等。这里放个人学术版的一些功能简介，包括应用范围，应用场景，模块数量等等。这里放个人学术版的一些功能简介，包括应用范围，应用场景，模块数量等等。这里放个人学术版的一些功能简介，包括应用范围，应用场景，模块数量等等。这里放个人学术版的一些功能简介，包括应用范围，应用场景，模块数量等等。这里放个人学术版的一些功能简介，包括应用范围，应用场景，模块数量等等。</div>
                            <div class="sybtn">立即使用</div>
                           </div> 
                           <img src="@/assets/ban3.png" class="faimg">
                   </div> 
              </el-collapse-item> -->
            </el-collapse>
             <div class="font40 mt_80 bordiv">{{infor.lxwm.title}}</div>
             <div class="mt_40" style="font-size: 20px;line-height: 35px;" v-html="infor.lxwm.content">
              


             </div>
             <div class="lxwm" @click="gourl(infor.lxwm.linkurl)">联系我们</div>
      </div>
      <IndexFooter></IndexFooter>
  </div>
</template>

<script>
import IndexFooter from '../components/common/indexFooter.vue';
import indexHeader from '../components/common/indexHeader.vue';
import { indexConfig } from "@/api/index.js"
export default {
  name: "HomePage",
  components:{indexHeader,IndexFooter},
  data() {
    return {
      activeName:'0',
      jjfa:'0',
      infor:{
        jjfa:[],
        jyfa:{},
        lxwm:{},
        ptys:[],
        yhhy:[]
      }
    }
  },
  created() {
    indexConfig().then(res=>{
      if(res.code==1){
        this.infor=res.data
      }
    })
  },
  methods:{
    handleClick(tab, event){
      console.log(tab, event);
    },
    gourl(url){
      window.open(url,'_blank')
    }
  }
}
</script>

<style scoped lang="less">
.index {
  .indexheader {position: sticky;left:0;top:0;background:#fff;z-index: 99;}
  .linediv {background:#005786;height:20px;}
  .indexm {
     display: flex;align-items:center;width:1200px;margin:30px auto 0px auto;padding-bottom:30px;
     .logo {width:400px;height:50px;}
     .logbtn {width:100px;height:35px;background:#2397CA;border-radius: 6px;color:#fff;font-size: 16px;text-align: center;line-height: 35px;cursor: pointer;}
     .zcbtn {width:100px;height:35px;border-radius: 6px;border:1px solid #2397CA;font-size: 16px;text-align: center;line-height: 35px;cursor: pointer;margin-left:20px;}
     .logbtn:hover {background:#10749f}
     .zcbtn:hover {border:1px solid #10749f;color:#10749f;}
  }
  .ban1 {width:450px;height:310px;border-radius:20px;}
  .title1 {font-size: 40px;font-family: Impact, Haettenschweiler, 'Arial Narrow Bold', sans-serif;}
  .title2 {font-size: 25px;}
  .desc {color:#6A6A6A;font-size: 16px;line-height: 30px;}
  .font40 {font-size:35px;}
   ::v-deep .el-tabs__item {font-size:25px;height:60px;
    &.is-active {color:#333;}
  } 
   ::v-deep .el-tabs__active-bar {height:4px;background:#005786}
   .bordiv {border-bottom:2px solid #E4E7ED;padding-bottom:20px;}
   .hydiv {
    border:1px  solid #C8C8C8;border-radius: 8px;padding:20px;
      .num {color:#2397CA;font-size: 55px;font-family: Impact, Haettenschweiler, 'Arial Narrow Bold', sans-serif}
      .hy1 {font-size: 25px;margin-top:15px;}
      .hydesc {color:#999999;font-size: 20px;margin-top:15px;}
   }
   .jjfabox {padding:0px 25px 10px 25px;color:#939393;font-size: 20px;line-height:35px;}
   .sybtn {
    width: 140px;color:#fff;font-size: 20px;text-align: center;line-height: 50px;margin-top:15px;cursor: pointer;
height: 50px;
background: #2397CA;
border-radius: 25px;
   }
   .faimg {width:450px;height:360px;border-radius: 20px;margin-left:50px;}
   ::v-deep .el-collapse-item {
    background: #FFFFFF;
box-shadow: 0px 0px 13px 4px rgba(0,0,0,0.05);
border-radius: 20px;margin-top:40px;
        .el-collapse-item__header {padding:20px;font-size: 25px;font-weight:bold;}
   }
   .lxwm {
    width: 169px;
height: 54px;
background: #4CAAD5;
border-radius: 8px;
border: 1px solid #5CA6D0;text-align: center;font-size: 20px;line-height: 54px;margin:50px auto  50px auto;cursor:pointer;color:#fff;
   }
   .lxwm:hover {background:#10749f}
  
}
</style>
